import {Block} from 'slate'

/**
 * A Slate plugin to insert a spesific node when enter is hit on a void node.
 *
 * @return {Object}
 */

function InsertOnEnterPlugin() {
    const blockArg = arguments[0];
    const shiftBlockArg = arguments[1];
    let blockInputProps, shiftBlockInputProps;
    let defaultProps = {object: 'block'};

    if (!blockArg) {
        throw new Error('You must pass a block type (string) or object for the block to insert.')
    }
    if (arguments[0].constructor.name === 'String') {
        blockInputProps = Object.assign({}, defaultProps, {type: blockArg})
    } else {
        blockInputProps = Object.assign(
            {},
            defaultProps,
            blockArg
        )
    }
    if (arguments[1] !== undefined) {
        if (arguments[1].constructor.name === 'String') {
            shiftBlockInputProps = Object.assign({}, defaultProps, {type: shiftBlockArg})
        } else {
            shiftBlockInputProps = Object.assign(
                {},
                defaultProps,
                shiftBlockArg
            )
        }
    } else {
        shiftBlockInputProps = blockInputProps;
    }

    function onKeyDown(e, editor, next) {
        const {value} = editor;
        if (e.key === 'Enter') {
            const { document, selection, startBlock} = value;
            const {start, end} = selection;
            if (startBlock.type === "editor") {
                return editor.insertInline(shiftBlockInputProps);
            }
            if (e.shiftKey) {
                return editor.insertInline(shiftBlockInputProps);
            }
            // if (startBlock && editor.query('isVoid', startBlock) && start.key === end.key) {
            //     const nextBlock = document.getNextBlock(start.key);
            //     const prevBlock = document.getPreviousBlock(start.key);
            //     const isFocusedStart = value.selection.focus.isAtStartOfNode(startBlock);
            //     const isFocusedEnd = value.selection.focus.isAtEndOfNode(startBlock);
            //     const blockToInsert = Block.create(blockInputProps);
            //
            //     // Void block at the end of the document
            //     if (!nextBlock) {
            //         return editor
            //             .moveToEndOfNode(startBlock)
            //             .insertBlock(blockToInsert)
            //             .moveToEnd()
            //     }
            //     // Void block between two blocks
            //     if (nextBlock && prevBlock) {
            //         return editor
            //             .moveToEndOfNode(startBlock)
            //             .insertBlock(blockToInsert)
            //     }
            //     // Void block in the beginning of the document
            //     if (nextBlock && !prevBlock) {
            //         return editor
            //             .moveToStartOfNode(startBlock)
            //             .insertNodeByKey(document.key, 0, blockToInsert)
            //     }
            // }
        }
        return next()
    }

    return {
        onKeyDown
    }
}

export default InsertOnEnterPlugin